import { inject } from 'vue';

export const trackingInjectKey = 'vp-tracking' as const;

export type EventName =
  'session_start' |
  'view_item' |
  'add_to_cart' |
  'begin_checkout' |
  'purchase' |
  'add_shipping_info' |
  'add_payment_info' |
  'access_code_applied';

export type UseTrackingComposable = {
  track: (...args: any[]) => void;
  trackEvent(name: EventName, payload?: unknown): void;
};

const useTracking = (): UseTrackingComposable => {
  const tracking = inject<UseTrackingComposable>(trackingInjectKey);

  if (!tracking) {
    throw new Error('useTracking can only be used as a child of TrackingProvider.');
  }

  return tracking;
};

export {
  useTracking,
};
